// extracted by mini-css-extract-plugin
export default {"menu-container":"SelectMenu_menu-container__9BG7+","menu-element":"SelectMenu_menu-element__m4Dmw"};